import React, { useState } from 'react';
//import Footer from '../My-comonent/Footer';
import investImage from '../images/invest.png';
import config from '../config/configuration_keys.json';
import axios from 'axios';
import MessageModal from '../components/MessageModal';
import RecaptchaCheckbox from '../components/RecaptchaCheckbox';

const WhistleBlowingForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    report: '',
    accountName: '',
    accountNumber: '',
    bankName: '',
  });
  const REACT_APP_API_URL = config.REACT_APP_API_URL;
  const [modalData, setModalData] = useState({
    show: false,
    title: '',
    message: '',
    closeButtonText: 'Close'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!recaptchaToken) {
      setRecaptchaError('Please complete the reCAPTCHA challenge.');
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${REACT_APP_API_URL}/api/whistleblow`, {
        ...formData,
        recaptchaToken
      });

      if (response.status === 200) {
        setModalData({
          show: true,
          title: '✅ Success',
          message: 'Whistleblow report has been sent successfully.',
          closeButtonText: 'OK'
        });

        setFormData({
          name: '',
          email: '',
          report: '',
          accountName: '',
          accountNumber: '',
          bankName: ''
        });
        setRecaptchaToken(null);
        setRecaptchaError('');
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setModalData({
          show: true,
          title: '⚠️ Missing Report',
          message: 'The report message is required. Please enter the report.',
          closeButtonText: 'Close'
        });
      } else {
        setModalData({
          show: true,
          title: '❌ Server Error',
          message: 'Something went wrong while sending your report. Please try again later or contact support.',
          closeButtonText: 'Close'
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <MessageModal
        show={modalData.show}
        handleClose={() => setModalData({ ...modalData, show: false })}
        title={modalData.title}
        message={modalData.message}
        closeButtonText={modalData.closeButtonText}
      />

      {/* Header image banner */}
      <div style={{ width: '100%', height: '300px', overflow: 'hidden' }}>
        <img
          src={investImage}
          alt="Whistleblowing Banner"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>

      {/* Form section */}
      <div style={{ maxWidth: 600, margin: 'auto', padding: 20, paddingTop: 40 }}>
        <h2>Whistleblowing Report</h2>
        <p>You can submit your concerns anonymously or include your contact.</p>

        <form onSubmit={handleSubmit}>
          <div>
            <label>Full Name (optional):</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              style={{ width: '100%', marginBottom: 10 }}
            />
          </div>
          <div>
            <label>Email (optional):</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              style={{ width: '100%', marginBottom: 10 }}
            />
          </div>
          <div>
            <label>Report / Concern:</label>
            <textarea
              name="report"
              value={formData.report}
              onChange={handleChange}
              required
              rows={6}
              style={{ width: '100%', marginBottom: 10 }}
            />
          </div>

          {/* Compensation account section */}
          <div style={{ marginTop: '2rem', backgroundColor: '#f8f8f8', padding: '1rem', borderRadius: '8px' }}>
            <h3>Compensation Account Details (Optional)</h3>
            <p>
              If you wish to be compensated after your report has been verified,
              please provide your bank account details below. This will remain confidential.
            </p>
            <div>
              <label>Account Name:</label>
              <input
                type="text"
                name="accountName"
                value={formData.accountName}
                onChange={handleChange}
                style={{ width: '100%', marginBottom: 10 }}
              />
            </div>
            <div>
              <label>Account Number:</label>
              <input
                type="text"
                name="accountNumber"
                value={formData.accountNumber}
                onChange={handleChange}
                style={{ width: '100%', marginBottom: 10 }}
              />
            </div>
            <div>
              <label>Bank Name:</label>
              <input
                type="text"
                name="bankName"
                value={formData.bankName}
                onChange={handleChange}
                style={{ width: '100%', marginBottom: 10 }}
              />
            </div>
          </div>

          <RecaptchaCheckbox
            value={recaptchaToken}
            onChange={(token) => {
              setRecaptchaToken(token);
              setRecaptchaError('');
            }}
            onError={(message) => setRecaptchaError(message)}
          />
          {recaptchaError && <p className="error">{recaptchaError}</p>}
          <button
            type="submit"
            style={{
              marginTop: '1.5rem',
              backgroundColor: isSubmitting ? '#ccc' : '#007bff',
              color: '#fff',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '4px',
              cursor: isSubmitting ? 'not-allowed' : 'pointer'
            }}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Submit Report'}
          </button>
        </form>
      </div>

      {/* Footer */}
    </div>
  );
};

export default WhistleBlowingForm;
